import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    equationClass: null,
  },

  mutations: {
    getEquationClassSuccess(state, equationClass) {
      state.equationClass = equationClass
    },
  },

  actions: {
    getEquationClass({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get('/service-workflows/get-equation-class')
          .then(res => {
            commit('getEquationClassSuccess', res.data.data.datas)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getTypes({commit}, id) {
        return new Promise((resolve, reject) => {
            axios.get('/service-workflows/types')
                .then(res => {
                    resolve(res.data.data.types)
                })
                .catch(error => {
                        reject(error)
                    })
                })
    },

    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/service-workflows/${id}`)
          .then(res => {
            resolve(res.data.data.workflow)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    create({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/service-workflows', data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/service-workflows/${data.id}`, data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    delete({commit}, countryId) {
      return new Promise((resolve, reject) => {
        axios.delete(`/service-workflows/${countryId}`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    restore({commit}, countryId) {
      return new Promise((resolve, reject) => {
        axios.put(`/service-workflows/${countryId}/restore`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    changeOrder({commit}, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin/service-workflows/result-equations/${params.item_id}/change-order`, params)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {
    all: (state) => state.all,
    equationClass: (state) => state.equationClass,
  },
}
